import React from "react"
import { Col, Container, Row } from "react-bootstrap"
import { graphql } from "gatsby"
import "./blockRestaurant.scss"
import Heading from "../blockHeading/heading";
import StyledButton from "../../common/styledButton"
import Media from "../media"
import {Parallax} from "react-scroll-parallax"

const BlkRestaurant = ({ content }) => {

    let alignment;
    if (content.block_medias_text_alignment) {
        alignment = content.block_medias_text_alignment;
    }

    return (
        <section className={"blk-restaurant " + alignment}>
            <Container>
                <Row>
                    <Col md={7}>
                        <div className="image-main">
                            {content.relationships.block_medias_text_medias[0] && (
                                <Media media={content.relationships.block_medias_text_medias[0]} />
                            )}

                            {content.relationships.block_medias_text_medias[1] && (
                                <div className="image-second">
                                    <Parallax speed={-8}>
                                        <Media media={content.relationships.block_medias_text_medias[1]} />
                                    </Parallax>
                                </div>
                            )}
                            {content.relationships.block_medias_text_medias[2] && (
                                <div className="image-third">
                                    <Parallax speed={8}>
                                        <Media media={content.relationships.block_medias_text_medias[2]} />
                                    </Parallax>
                                </div>
                            )}
                        </div>
                    </Col>
                    <Col md={5}>
                        <div>
                            <Heading
                                caption={content.block_medias_text_caption}
                                title={content.block_medias_text_title}
                                description={content.block_medias_text_description.processed}
                            />
                            {content.block_medias_text_link &&
                                <StyledButton
                                    title={content.block_medias_text_link.title}
                                    path={content.block_medias_text_link.url}
                                    type="link"
                                />
                            }
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )

}

export const query = graphql`
  fragment getParagraphBlockMediasText on paragraph__block_medias_text {
    internal {
        type
    }
    block_medias_text_alignment
    block_medias_text_caption
    block_medias_text_description {
      processed
    }
    block_medias_text_link {
      title
      url
    }
    block_medias_text_title
    relationships {
        block_medias_text_medias {
            ...getImageVideo
        }
    }
  }
`

export default BlkRestaurant
